import React from 'react';
import { useFieldAttributes } from '../../../services/field-attributes';
import { FieldDescriptionWUT } from '../../../ui/field-description/field-description-wut';
import { FieldErrorWUT } from '../../../ui/field-error/field-error-wut';
import { FieldLabelWUT } from '../../../ui/field-label/field-label-wut';
import { TimeField } from '../../../ui/time-field';
import { Widget } from '../../../ui/widget/widget';
export const TimeInputWUT = ({ id, disabled, readOnly, hidePlaceholder, value, use24HourFormat, onChange, onBlur, onFocus, description, target, error, hasError = false, errorMessage, required, label, hideLabel, requiredIndicatorType, requiredIndicatorPlacement, FieldLayout, widgetHtml, widgetEnabled })=>{
    const { labelId, inputId, errorId, descriptionId, ariaDescribedBy } = useFieldAttributes(id, error, description);
    return /*#__PURE__*/ React.createElement(FieldLayout, {
        fieldId: id,
        renderLabel: ()=>/*#__PURE__*/ React.createElement(FieldLabelWUT, {
                labelId: labelId,
                required: required,
                label: label,
                hideLabel: hideLabel,
                requiredIndicatorType: requiredIndicatorType,
                requiredIndicatorPlacement: requiredIndicatorPlacement
            }),
        renderInput: ()=>widgetHtml && widgetEnabled ? /*#__PURE__*/ React.createElement(Widget, {
                fieldId: id,
                widgetHtml: widgetHtml,
                onChange: onChange,
                value: value
            }) : /*#__PURE__*/ React.createElement(TimeField, {
                disabled: disabled,
                readOnly: readOnly,
                id: id,
                hidePlaceholder: hidePlaceholder,
                required: required,
                value: value ?? undefined,
                use24HourFormat: use24HourFormat,
                onChange: onChange,
                onBlur: onBlur,
                onFocus: onFocus,
                inputId: inputId,
                error: hasError,
                ariaLabelledBy: labelId,
                ariaDescribedBy: ariaDescribedBy
            }),
        renderDescription: ()=>/*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(FieldErrorWUT, {
                target: target,
                hasError: hasError,
                errorMessage: errorMessage,
                id: errorId
            }), /*#__PURE__*/ React.createElement(FieldDescriptionWUT, {
                description: description,
                id: descriptionId
            }))
    });
};

//# sourceMappingURL=time-input-wut.js.map